import { render, staticRenderFns } from "./StaffViewList.vue?vue&type=template&id=4ae09924&scoped=true&"
import script from "./StaffViewList.vue?vue&type=script&lang=js&"
export * from "./StaffViewList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae09924",
  null
  
)

export default component.exports